import { render, staticRenderFns } from "./ResidentManager.vue?vue&type=template&id=559437e2&scoped=true"
import script from "./ResidentManager.vue?vue&type=script&lang=js"
export * from "./ResidentManager.vue?vue&type=script&lang=js"
import style0 from "./ResidentManager.vue?vue&type=style&index=0&id=559437e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559437e2",
  null
  
)

export default component.exports